import React from 'react';
import { Countdown } from './Countdown';
export function Urgency() {
  return <section className="w-full bg-pine" data-id="element-370" data-mp="2bwe6imbbrd3g">
      <div className="mx-auto max-w-3xl px-5 py-12 text-center sm:py-16" data-id="element-371" data-mp="2bvcvuiy80sm9">
        <p className="eyebrow text-ember" data-id="element-372" data-mp="1wzwzg7a64kmp">Limited-time offer</p>
        <h2 className="mt-3 font-display text-3xl uppercase text-paper sm:text-5xl" data-id="element-373" data-mp="1x1rgvbm8dum1">
          The launch price ends in:
        </h2>
        <div className="mt-6" data-id="element-374" data-mp="1o6jyci1yacpj">
          <Countdown tone="dark" data-id="element-375" data-mp="1o5ijs3lq7832" />
        </div>
        <p className="mt-5 text-sm text-paper/75" data-id="element-376" data-mp="1sxjrdc7y8amr">
          After that the price goes up by{' '}
          <span className="font-bold text-ember" data-id="element-377" data-mp="1e95qh6u3ew8u">$42</span> and stays there.
        </p>
      </div>
    </section>;
}